import React from "react";
import style from "./OrderInfoAviationMobileActions.module.scss";
import ClientActionsTab from "./components/client/ClientActionsTab";
import ExpeditorActionsTab from "./components/expeditor/ExpeditorActionsTab";

const OrderInfoAviationMobileActions = ({
  order,
  statusHistory = [],
  suggestedPrices = [],
  fetchOrderData,
  onForceUpdate,
  refreshDocuments,
  onClose,
  user,
}) => {
  if (!order) return null;

  if (user?.type === "Client") {
    return (
      <div className={style.wrapper}>
        <ClientActionsTab
          order={order}
          statusHistory={statusHistory}
          suggestedPrices={suggestedPrices}
          fetchOrderData={fetchOrderData}
          onForceUpdate={onForceUpdate}
        />
      </div>
    );
  }

  if (user?.type === "Expeditor") {
    return (
      <div className={style.wrapper}>
        <ExpeditorActionsTab
          order={order}
          history={statusHistory}
          fetchOrderData={fetchOrderData}
          onForceUpdate={onForceUpdate}
          refreshDocuments={refreshDocuments}
          onClose={onClose}
        />
      </div>
    );
  }

  return null;
};

export default OrderInfoAviationMobileActions;
